import styles from "./TourInfo.module.css";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import React, { useState } from "react";
import Input from "./../common/input/Input";
import MapContainer from "../map-container/MapContainer";
import { uploadTourPoster } from './../../services/CloudStorage.service';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { tourErrorInfoSelector } from "../../hooks/store/getters";
import { useAppStore } from "../../hooks/store/useAppStore";

const TourInfo = ({
  tourInfo,
  tourInfoInputChangeHandler,
  handleMarkerUpdate,
  handleTourPosterUpload,
}) => {

  const [progress, setProgress] = useState(null);
  const tourError = useAppStore(tourErrorInfoSelector);
  
  
  const tourPosterHandleChange = async (event) => {
    
    const file = URL.createObjectURL(event.target.files[0]);
    handleTourPosterUpload({ file });

    const fileUploadUrl = url => handleTourPosterUpload({ url, file });
    
    await uploadTourPoster(event.target.files[0], setProgress, fileUploadUrl);
    
  };

  const fileUrl = tourInfo.tourPoster.url || tourInfo.tourPoster.file;

  return (
    <div className={styles.tourInfo}>
      <div className={styles.tourInfoHeader}>
        <h2 className={styles.pageTitle}>Tour Info</h2>
        <span className={styles.pageSubtitle}>
          Enter tour details and location
        </span>
      </div>
      <div className={styles.tourPoster}>
        {fileUrl && (
          <img className={styles.tourPosterImg} src={fileUrl} alt="poster" />
        )}
        <div className={styles.tourPosterImgTint}></div>
        <Button className={styles.tourPosterUploadBtn}
          disabled={progress}
          variant="dark" 
        >
          { fileUrl && !progress ? 'Change' : 'Upload' } Tour Poster
          {progress ? (
            <ProgressBar animated now={progress} label={`${progress}%`} />
          ) : null}
        </Button>
     
        <Input
          type="file"
          className={styles.tourPosterFileInput}
          onChange={tourPosterHandleChange}
          error={tourError.url}
          />
      </div>
      <div className={styles.createTourForm}>
        <Row>
          <Col md={6}>
            <Input
              label="Tour Name"
              name="tourName"
              value={tourInfo.tourName}
              onChange={(e) => tourInfoInputChangeHandler(e)}
              error={tourError.tourName}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Input
              type="textarea"
              name="tourDescription"
              label="Tour Description"
              value={tourInfo.tourDescription}
              onChange={(e) => tourInfoInputChangeHandler(e)}
              error={tourError.tourDescription}
            />
          </Col>
        </Row>
        <Row>
          <Col md={5}>
            <Input
              label="Tour City"
              name="tourCity"
              value={tourInfo.tourCity}
              onChange={(e) => tourInfoInputChangeHandler(e)}
              error={tourError.tourCity}
            />
            <Input
              label="Tour Country"
              name="tourCountry"
              value={tourInfo.tourCountry}
              onChange={(e) => tourInfoInputChangeHandler(e)}
              error={tourError.tourCountry}
            />
            <Row>
              <Col md={6}>
                <Input
                  label="Lattitude"
                  name="latitude"
                  value={tourInfo.latitude}
                  onChange={(e) => tourInfoInputChangeHandler(e)}
                  error={tourError.latitude}
                  disabled={true}
                />
              </Col>
              <Col md={6}>
                <Input
                  label="Longitude"
                  name="longitude"
                  value={tourInfo.longitude}
                  onChange={(e) => tourInfoInputChangeHandler(e)}
                  error={tourError.longitude}
                  disabled={true}
                />
              </Col>
            </Row>
          </Col>
          <Col md={7}>
            <div className={styles.formGroup}>
              <label className={styles.label}>Tour Location</label>
              <div className={styles.mapContainer}>
                <MapContainer
                  handleMarkerUpdate={handleMarkerUpdate}
                  position={{ lat: tourInfo.latitude, lng: tourInfo.longitude, }}
                  zoom={tourInfo.zoom}
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default TourInfo;
